import { Box, Button, Stack, Typography } from '@mui/material'
import GTImage1 from '../../components/images/framedGTImage1.png'
import GTImage2 from '../../components/images/framedGTImage2.png'
import GTImage3 from '../../components/images/framedGTImage3.png'
import GTImage4 from '../../components/images/framedGTImage4.png'
import useMediaQuery from '@mui/material/useMediaQuery'
import { palette } from '../../myTheme'

const imageArray = [GTImage1, GTImage2, GTImage3, GTImage4]

export default function GTAppPage() {
  const isScreenSmall = useMediaQuery('(max-width: 1000px)')
  return (
    <Box margin={isScreenSmall ? 6 : 12}>
      <Stack spacing={8}>
        <Stack
          direction='row'
          style={{
            paddingBottom: 8,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography fontWeight={800} fontSize={isScreenSmall ? 18 : 70}>
            Sprouts: Grocery Tracker
          </Typography>
          <Button
            style={{
              marginTop: isScreenSmall ? 0 : 13,
              maxHeight: isScreenSmall ? 40 : 80,
              fontSize: isScreenSmall ? 16 : 30,
            }}
            onClick={() => window.history.back()}
          >
            Back
          </Button>
        </Stack>
        <Typography
          style={{ textAlign: isScreenSmall ? 'center' : 'start' }}
          fontStyle={{ color: palette.white }}
          fontWeight={400}
          fontSize={isScreenSmall ? 14 : 20}
        >
          Sprouts is a simple but effective way to make sure you can see which
          groceries are going bad and which need to be cooked soon. log your
          groceries and their expiration dates when you buy them and the app
          will let you know when specific ingredients are nearing their
          expiration date.{' '}
        </Typography>
        <Stack
          direction="row"
          spacing={6}
          style={{
            overflowX: isScreenSmall ? 'auto' : 'visible',
            flexWrap: isScreenSmall ? 'nowrap' : 'wrap',
            scrollSnapType: isScreenSmall ? 'x mandatory' : 'none',
            justifyContent: 'space-evenly'
          }}
        >
          {imageArray.map((imgSrc, index) => (
            <Box
              key={index}
              component="img"
              src={imgSrc}
              alt={`Image ${index}`}
              sx={{
                height: 450,
                borderRadius: 2,
                flexShrink: 0,
                scrollSnapAlign: isScreenSmall ? 'start' : 'none',
              }}
            />
          ))}
        </Stack>

        <Typography variant='h3'>Feature Roadmap:</Typography>
        <Stack paddingLeft={4}>
          <Typography sx={{ display: 'list-item' }}>
            Conversational item entry using apples LLM frameworks: short term. I'm currently
            building a feature that enables conversational entry of grocery
            items using Apple’s on-device large language models. With this feature,
            users will be able to quickly log groceries by simply describing what they bought—no
            tapping or typing required. This makes tracking more natural, faster, and easier to integrate into your daily routine.
          </Typography>
          <Typography sx={{ display: 'list-item' }}>
            Statistics: Short Term. With this feature, you will be able to track
            how you are doing with your groceries, how many expire before being
            eaten, and many more informative metrics.
          </Typography>
          <Typography sx={{ display: 'list-item' }}>
            Recipes: Medium Term. With Recipes, Sprouts is going to level up as
            a grocery tracker. You can group your grocery items into recipes and
            log them as consumed with 1 click. An example would be you cook a
            meal that uses 1 pound of chicken breasts, 8 ounces of mushrooms,
            and 1 pound of Brussels sprouts. You simply log in the app you made
            this saved recipe and it will erase the items and their quantities
            from your grocery tracking list. This feature will most likely come
            in a few phases with Sprouts eventually recommending saved recipes
            based on what you have logged.
          </Typography>
          <Typography sx={{ display: 'list-item' }}>
            Barcode Scanning: Long Term. Bardcode scanning to allow for easy
            logging is a feature that I think will really take this app to the
            next level of usefullness. This feature will allow nearly instant
            logging as you put your groceries way and eliminate the manual entry
            step that is very time consuming, especially for big orders.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  )
}
